import "core-js/modules/es.object.assign.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CircleBubble from '@/components/common/CircleBubble';
import { viewStats } from '../../utils/Analytics';
import { isProd } from '@/config';
export default {
  name: 'category-list',
  components: {
    CircleBubble: CircleBubble
  },
  props: {
    categoryList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      pageCategoryList: [],
      scrollPercent: 0
    };
  },
  mounted: function mounted() {
    // 添加滚动事件监听
    this.addListener2ScrollEl();
  },
  methods: {
    onScroll: function onScroll(e) {
      if (e && e.target) {
        this.scrollPercent = Math.floor(e.target.scrollLeft / e.target.scrollWidth * 100);
      }
    },
    onCategoryClick: function onCategoryClick(content) {
      var jumpUrl = content.jumpUrl,
        dataSeed = content.dataSeed;
      if (!jumpUrl) return;
      this.go(jumpUrl, {
        _blank: true
      });
      if (dataSeed) {
        window.seedAction(Object.assign({}, dataSeed, {
          needTag: true
        }));
      }
    },
    /**
     * 添加滚动事件监听
     */
    addListener2ScrollEl: function addListener2ScrollEl() {
      // 捕获 dom 获取失败错误
      try {
        var scrollEl = document.getElementById('bubble-wrap-test-scroll-view-stats');
        if (!scrollEl) throw new Error('scrollEl获取失败');
        scrollEl.addEventListener('scroll', window.StatusReportData, false);
        viewStats({
          target: {
            id: 'bubble-wrap-test-scroll-view-stats'
          }
        });
      } catch (err) {
        this.$owlReportError('演出首页-金刚位异常', err);
      }
    }
  }
};